import MetaIcon from "@/components/ui/OpticksIcons/MetaIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import MetaIntegrationStep2 from "./steps/components/MetaIntegrationStep2";
import MetaIntegrationStep3 from "./steps/components/MetaIntegrationStep3";
import MetaIntegrationStep4 from "./steps/components/MetaIntegrationStep4";
import { userIsDemo } from "@/utilities/planHelpers";
import { useUsersStore } from "@/zustand/usersStore";
import MetaIntegrationStep1 from "./steps/components/MetaIntegrationStep1";

const metaConfig: ChannelIntegrationConfig = {
  channelName: "Meta Ads",
  channelDisplayName: "Meta",
  platformKey: "facebook",
  oauthPlatformKey: "facebook",
  icon: <MetaIcon size={32} />,
  supportsOAuth: false,
  overviewPath: routesMap.integration.meta.overview.path,
  linkingPath: routesMap.integration.meta.linking.path,
  pixelManagementPath:
    routesMap.integration.channelsCenter.path + "?channel=meta",
  guideSteps: [
    {
      content: (stepLabel) => <MetaIntegrationStep1 stepLabel={stepLabel} />,
      manualOnly: true,
    },
    {
      content: (stepLabel) => <MetaIntegrationStep2 stepLabel={stepLabel} />,
      manualOnly: false,
    },
    {
      content: (stepLabel) => <MetaIntegrationStep3 stepLabel={stepLabel} />,
      manualOnly: false,
    },
    {
      content: (stepLabel) => <MetaIntegrationStep4 stepLabel={stepLabel} />,
    },
  ],
};

const MetaIntegration = () => {
  const user = useUsersStore((state) => state.user);
  const isDemo = userIsDemo(user);

  return (
    <ChannelIntegrationGuide config={metaConfig} isOAuthAvailable={!isDemo} />
  );
};

export default MetaIntegration;
